import React, { Component } from "react";
import { connect } from "react-redux";
import ScrollContainer from "react-indiana-drag-scroll";
import "../style.css";
import CountryItem from "./CountryItem";
import { CircularProgress } from "@material-ui/core";

class CountriesList extends Component {
  render() {
    const {
      language,
      countries,
      countriesFullyLoaded,
      selectedCountryID,
    } = this.props;
    return (
      <div style={{ marginTop: 30 }}>
        <p
          className="box-title"
          style={{ textAlign: language === "arabic" ? "right" : "left" }}
        >
          {language == "arabic" ? "الدولة" : "Country"}
        </p>
        <div
          className="bordered"
          style={{
            height: 105,
            backgroundColor: "white",
            display: !countriesFullyLoaded && "grid",
          }}
        >
          {countriesFullyLoaded ? (
            <ScrollContainer
              style={{
                display: "grid",
                gridTemplateColumns: `repeat(${
                  countries.length + 1
                }, min-content)`,
                overflow: "auto",
                height: 105,
                paddingRight: 10,
                paddingLeft: 10,
                width: "100%",
                direction: language == "english" ? "ltr" : "rtl",
                alignItems: "center",
              }}
              className="disable-scroll-bar w-100"
            >
              {countries.map((country) => (
                <CountryItem
                  key={Math.random() * 99999}
                  id={country.id}
                  flag={country.flag}
                  isSelected={country.id === selectedCountryID}
                  setSelectedCountry={(id) => this.props.setSelectedCountry(id)}
                />
              ))}

              <div
                style={{
                  width: 10,
                  height: 60,
                  display: "grid",
                }}
              ></div>
            </ScrollContainer>
          ) : (
            <CircularProgress
              color="primary"
              style={{
                alignSelf: "center",
                justifySelf: "center",
                width: 30,
                height: 30,
              }}
            />
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    countries: state.store.store.all_countries || state.store.store.countries,
    language: state.store.language,
    countriesFullyLoaded: !state.store.thirdLoading,
  };
};
export default connect(mapStateToProps)(CountriesList);
